import { render, staticRenderFns } from "./BlogAuthorBio.vue?vue&type=template&id=cd409070"
import script from "./BlogAuthorBio.vue?vue&type=script&lang=js"
export * from "./BlogAuthorBio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports